import { render } from "./SignupPage.vue?vue&type=template&id=13aaa38d"
import script from "./SignupPage.vue?vue&type=script&lang=js"
export * from "./SignupPage.vue?vue&type=script&lang=js"
script.render = render

export default script